import { useEffect, useState, React } from "react";
import { BrowserRouter, Route, Routes, Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useAuthContext } from "../../Hooks/useAuthContext";
import Spinner from "../../Components/Loading/Spinner";
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { MapContainer, TileLayer, useMap, Marker, Popup } from 'react-leaflet'
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

import { apiService } from "../../Axios/apiService"; 
import moment from "moment";
import SoilSamplingTable from "../../Components/Projects/SoilSamplingTable";

export default function ViewProject() {
  const params = useParams();
    const { user } = useAuthContext();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [project, setProject] = useState();

    const DefaultIcon = L.icon({
        iconUrl: icon,
        shadowUrl: iconShadow,
        iconSize: [30, 50],
        iconAnchor: [15, 50]
    });
    L.Marker.prototype.options.icon = DefaultIcon;



    // Load user
    useEffect(() => {
        console.log("loading project...",params.id);

        apiService("get", `projects/${params.id}`, null,
            (response) => {
                console.log("Project:", response);
                setProject(response);
                setLoading(false);
            },
            (error) => {
                console.log(error);
                setLoading(false);
            }
        )
       
            
          
    }, [])

    const styles = {
        tableRow: {
            fontSize: 15,
            color: "#888", 
        }
    }

    function duplicateProject() {
        if (window.confirm("Are you sure you want to duplicate this project?")) {
            apiService("post", `projects/${project.id}/duplicate`, null,
                (response) => {
                    console.log("Project duplicated:", response);
                    navigate(`/Projects/Edit/${response.id}`);
                },
                (error) => {
                    console.log(error);
                    alert("An error occurred while duplicating the project. Please try again.");
                }
            )
        }
    }

    
    
    return (
        <div className="page">
            {loading && (<Spinner />)}
            {!loading && project && (
                <>
                <div className="row">
                    <div className="col-8">
                  
                        <h1>
                            {project.id} - {project.title} ({project.farm.name}) - <small>{project.year}</small>
                            <Link to={`/Projects/Edit/${project.id}`} className="btn-sm btn-other" style={{ marginLeft: 10 }}>Edit</Link>
                            <button onClick={() => duplicateProject()} className="btn-sm btn-other" style={{ marginLeft: 10 }}>Duplicate</button>
                            <br />
                            <small style={{ fontSize: 18 }}>Status: {project.status}</small>
                        </h1>
                       
                
                        <h3>Project Details</h3>

                        {/* Farm Name */ }
                        <div className="row gx-0">
                            <div className="col-4">
                                Farm Name
                            </div>
                            <div className="col-6">
                                    <a href={`/Farms/View/${project.farm.id}`}>
                                        {project.farm.name}
                                        {project.farm.businessName && ` (${project.farm.businessName})`}
                                    </a>
                            </div>
                        </div>

                        {/* Address */}
                        <div className="row gx-0">
                            <div className="col-4">
                                Address
                            </div>
                            <div className="col-6" style={{ whiteSpace: "pre-line" }}>
                                {project.farm.address || project.postcode ? (
                                    <div>
                                        {project.farm.address && <>{project.farm.address}<br /></>}
                                        {project.farm.postcode}
                                    </div>
                                ) : (
                                    <em>No address set</em>
                                )}
                            </div>
                        </div>

                        {/* Primary Contact */}
                        <div className="row gx-0">
                            <div className="col-4">
                                Primary Contact
                            </div>
                            <div className="col-6">{project.farm.primaryContact}</div>
                        </div>

                        {/* Notes */}
                        <div className="row gx-0">
                            <div className="col-4">
                                Notes
                            </div>
                            <div className="col-6" style={{ whiteSpace: "pre-line" }}>{project.notes || <em>No notes recorded</em>}</div>
                        </div>



                        <hr/>

                        {/* Tasks */}
                        <div className="row gx-0">
                            <div className="col-12">
                                <h3>Tasks</h3>
                            </div>
                        </div>


                        
                        <div className="row gx-0">
                            <div className="col-4"><strong>Title</strong></div>
                            
                            <div className="col-2"><strong>Due</strong></div>
                            <div className="col-2"><strong>Completed</strong></div>
                            <div className="col-2"><strong>Invoiced</strong></div>
                            <div className="col-2"><strong>Status</strong></div>
                        </div>


                        {project.tasks && project.tasks.map((item, index) => (

                            <div className="row gx-0">
                                <div className="col-4" style={styles.tableRow}>{item.title}</div>
                                {item.status != "Not Required" ? (
                                    <>
                                        <div className="col-2" style={{
                                            ...styles.tableRow,
                                            color: "#006403",
                                            fontWeight: "bold"
                                        }}>{moment(item.dueDate).format("DD/MM/YYYY")}</div>

                                        <div className="col-2">{item.completedDate && moment(item.completedDate).format("DD/MM/YYYY")}</div>
                                        <div className="col-2">{item.invoicedDate && moment(item.invoicedDate).format("DD/MM/YYYY")}</div>
                                    </>
                                ) : (
                                        <div className="col-2" style={styles.tableRow}>Not Required</div>
                                )}
                                <div className="col-2" style={styles.tableRow}>
                                    {item.status != "Not Required" ? item.status : ""}
                                    {item.status == "Completed" && item.completedDate && (<div>({moment(item.completedDate).format("DD/MM/YYYY")})</div>) }
                                </div>
                                
                            </div>

                        ))}

                   

                        <hr />

                        </div>

                        {/* Location map */}
                        <div className="col-4 text-end">
                            <div >
                                <MapContainer center={[project.farm.latitude ?? -3, project.farm.longitude ?? 55]} zoom={8} scrollWheelZoom={false} style={{ height: 400, width: '100wh' }}>
                                    <TileLayer
                                        attribution="Imagery &copy; <a href='https://www.mapbox.com/'>Mapbox</a>"
                                        url="https://api.tiles.mapbox.com/v4/mapbox.satellite/{z}/{x}/{y}.png?access_token=pk.eyJ1IjoiaXRhZGNvbGxlY3QiLCJhIjoiY2szNXNhemdoMGx1aTNocGU3bGRwMjJpbSJ9.V7BIAIP0gFWXMzi9Uq-9QQ"
                                    />
                                    {project.farm.longitude && (
                                        <Marker position={[project.farm.latitude ?? -3, project.farm.longitude ?? 53]}>
                                            <Popup>
                                                <strong>{project.farm.name}</strong><br />
                                                {project.farm.address} <br />
                                                {project.farm.postcode}.
                                            </Popup>
                                        </Marker>
                                    )}
                                </MapContainer>
                            </div>
                        </div>
                </div>


                    {/* Soil sampling removed for the time being. Will be re-introduced after mapping */
                    /*<SoilSamplingTable soilSamples={project.soilSamples} />*/}


                    <div className="row">
                        <div className="col-12">



                        { /* Farm Visit Sheet Survey */}
                        <div className="row gx-0" >
                            <div className="col-md-12">
                                <h3 style={{ marginTop: 20 }}>Farm Visit Sheet</h3>
                            </div>
                        </div>

                        <div className = "row gx-0" >
                            <div className="col-md-6">
                                { /* Reason Behind NMP */}
                                <div className="form-group">
                                    <label>Reason for NMP, Red Tractor, SFI or EA. Does it require slurry storage, NVZ calculations and a SMP?</label>
                                    <p>{project.reasonBehindNMP}</p>
                                </div>


                                { /* Herbal Leys/Clover/Reseeds */}
                                <div className="form-group">
                                    <label>Herbal Leys / Clover / Reseeds (% Mix)</label>
                                    <p>{project.herbalLeysCloverReseeds}</p>
                                </div>


                                { /* Grassland Information */}
                                <div className="form-group">
                                    <label>
                                        Grassland Details
                                    </label>
                                    <p>{project.grasslandInformation}</p>
                                </div>


                            </div>
                            <div className="col-md-6">
                                { /* Arable */}
                                <div className="form-group">
                                    <label>Arable Details</label>
                                    <p>{project.arableDetails}</p>
                                </div>


                                { /* Organic Manure */}
                                <div className="form-group">
                                    <label>Organic Manure Details</label>
                                        <p>{project.organicManureDetails}</p>
                                </div>


                                { /* Fertiliser Application */}
                                <div className="form-group">
                                    <label>Fertiliser Details</label>
                                    <p>{project.fertiliserDetails}</p>
                                </div>

                                
                            </div>
                        </div>

                        <hr/>
                        <div className="row gx-0" >
                            <div className="col-12">

                                { /* Livestock Header */}
                                <div className="col-12">
                                    <h3 style={{ marginTop: 20 }}>Livestock Information</h3>
                                </div>


                                {project.livestock && project.livestock.length > 0 ? (
                                    <div className="row gx-0">

                                        {/* Number */}
                                            <div className="col-2 gx-0">
                                            <strong>Number</strong>
                                        </div>

                                        {/* Type */}
                                        <div className="col-5">
                                            <strong>Type</strong>
                                        </div>

                                        {/* Months Housed */}
                                        <div className="col-2">
                                            <strong>Months Housed</strong>
                                        </div>

                                        {/* Slurry / Straw System */}
                                        <div className="col-2">
                                            <strong>Slurry / Straw System</strong>
                                        </div>
                                    </div>
                                ) : (
                                        <div className="row gx-0">
                                        <div className="col-12">
                                            <em>No livestock information available</em>
                                        </div>
                                    </div>
                                )}

                                {project.livestock && project.livestock.map((item, index) => (
                                    <div className="row gx-0">

                                        {/* Number */}
                                        <div className="col-2 gx-0">
                                            {item.number}
                                        </div>

                                        {/* Type */}
                                        <div className="col-5">
                                            {item.type}
                                        </div>

                                        {/* Months Housed */}
                                        <div className="col-2">
                                            {item.monthsHoused} Month(s)
                                        </div>

                                        {/* Slurry / Straw System */}
                                        <div className="col-2">
                                            {item.slurryOrStraw}
                                        </div>
                                
                                    </div>
                                ))}
                            </div>
                            </div>

                            <hr />
                            <div className="row gx-0" >
                                <div className="col-12">

                                    { /* Slurry Store Header */}
                                    <div className="col-12">
                                        <h3 style={{ marginTop: 20 }}>Slurry Store Information</h3>
                                    </div>


                                    {project.slurryStores && project.slurryStores.length > 0 ? (
                                        <div className="row gx-0">

                                            {/* Type Of Store */}
                                            <div className="col-2 gx-0">
                                                <strong>Type Of Store</strong>
                                            </div>

                                            {/* Dimensions (LxDxW) */}
                                            <div className="col-2 gx-0">
                                                <strong>Dimensions (LxDxW)</strong>
                                            </div>

                                            {/* Capacity */}
                                            <div className="col-2 gx-0">
                                                <strong>Capacity</strong>
                                            </div>

                                            {/* Covered */}
                                            <div className="col-2 gx-0">
                                                <strong>Covered?</strong>
                                            </div>

                                            {/* Drainage Area */}
                                            <div className="col-2 gx-0">
                                                <strong>Drainage Area</strong>
                                            </div>

                                            
                                            
                                        </div>
                                    ) : (
                                        <div className="row gx-0">
                                            <div className="col-12">
                                                <em>No slurry store information available</em>
                                            </div>
                                        </div>
                                    )}

                                    {project.slurryStores && project.slurryStores.map((item, index) => (
                                        <div className="row gx-0">

                                            {/* Type Of Store */}
                                            <div className="col-2 gx-0">
                                                {item.typeOfStore}
                                            </div>

                                            {/* Dimensions (LxDxW) */}
                                            <div className="col-2 gx-0">
                                                {item.length}x{item.depth}x{item.width} {item.isMetres ? "m" : "ft"}
                                            </div>

                                            {/* Capacity */}
                                            <div className="col-2 gx-0">
                                                {item.capacity} {item.isMetres ? "m³" : "ft³"}
                                            </div>

                                            {/* Covered */}
                                            <div className="col-2 gx-0">
                                                {item.isCovered ? "Yes" : "No"}
                                            </div>

                                            {/* Drainage Area */}
                                            <div className="col-2 gx-0">
                                                {item.drainageArea} {item.isMetres ? "m" : "ft"}<sup>2</sup>
                                            </div>

                                            

                                        </div>
                                    ))}
                                </div>
                            </div>


                        </div>
                        </div>
                        
                        
                    </>

                    
               

            )}
        </div>
  )
}
